// extracted by mini-css-extract-plugin
export default {"countdown":"TimeAlarm_countdown__Y0-Gb"};